<template>
    <n-alert
      v-if="showWarning"
      title="浏览器兼容性提示"
      type="warning"
      class="compatibility-warning"
      closable
      @close="dismissWarning"
    >
      检测到您正在使用的浏览器可能存在兼容性问题，建议使用最新版的
      <strong>Google Chrome</strong> 或 <strong>Microsoft Edge</strong>
      以获得最佳体验。
    </n-alert>
  </template>
  
  <script setup>
  import { ref, onMounted } from 'vue';
  
  const showWarning = ref(false);
  
  // 关闭提示并将状态保存到localStorage
  const dismissWarning = () => {
    showWarning.value = false;
    localStorage.setItem('compatibilityWarningDismissed', 'true');
  };
  
  const checkCompatibility = () => {
    // 首先检查localStorage中是否已经存在标记
    if (localStorage.getItem('compatibilityWarningDismissed') === 'true') {
      return; // 如果用户已经关闭过提示，不再显示
    }
    
    const ua = navigator.userAgent.toLowerCase();
  
    // 匹配一些低版本或小众浏览器
    const incompatibleBrowsers = [
      /miuibrowser/, 
      /mqqbrowser/,  
      /ucbrowser/,   
      /baidubrowser/, 
      /sogoumobilebrowser/,
      /2345explorer/,
      /lbbrowser/,
      /metasr/,
      /msie/,
    ];
  
    // 如果匹配到任何一个
    for (const pattern of incompatibleBrowsers) {
      if (pattern.test(ua)) {
        showWarning.value = true;
        return;
      }
    }
  
    // 检查 Chrome 或 Edge 是否为旧版本（示例：小于 90）
    const chromeMatch = ua.match(/chrome\/(\d+)/);
    const edgeMatch = ua.match(/edg\/(\d+)/);
  
    const version = chromeMatch?.[1] || edgeMatch?.[1];
    if (version && parseInt(version) < 90) {
      showWarning.value = true;
    }
  };
  
  onMounted(() => {
    checkCompatibility();
  });
  </script>
  
  <style scoped>
  .compatibility-warning {
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    max-width: 90%;
    z-index: 1000;
  }
  </style>
  